// 10 powerful landing-page quotes — shared by the hero quote carousel and the
// "Words that carry our legacy" band above the footer.
export const LEGACY_QUOTES = [
    "Created in India. By Indians. For every Indian family—because every heritage deserves to be preserved.",
    "One India. Thousands of traditions. One platform to preserve them all.",
    "Whatever your religion, community, ethnicity or tradition—your family legacy has a place here.",
    "India's diversity is our strength. Your family's uniqueness is your legacy.",
    "More than 1,000 ways to preserve your heritage—and the freedom to add your own.",
    "If your tradition has no field, create one. Your heritage should never be limited by a template.",
    "Built for India's diversity. Designed for every family. Created to preserve every legacy.",
    "Your religion. Your traditions. Your rituals. Your family story. Preserve them your way.",
    "No tradition is too unique. No family story is too small. Every legacy deserves to live on.",
    "India has thousands of traditions. Your family has its own. Preserve yours before it disappears.",
];

// 20 brand statements for Family Repository (master doc).
export const BRAND_STATEMENTS = [
    "India's Family Heritage. One Digital Home.",
    "India's First Holistic Family Legacy Preservation Platform.",
    "One Digital Operating System, One Platform. Every Family. Every Tradition.",
    "Preserving India's Roots. Connecting Its Generations.",
    "The Digital Home of India's Living Traditions.",
    "Beyond a Family Tree. An Entire Family Universe.",
    "Every Family Has a Legacy. Every Legacy Deserves Preservation.",
    "One Nation. Countless Cultures. One Family Heritage Platform.",
    "From Family Roots to Future Generations.",
    "India's Heritage Begins at Home.",
    "Your Family's Past. Your Children's Inheritance.",
    "Every Ritual Has a Story. Every Tradition Has a Meaning.",
    "A Digital Revolution in Family Legacy Preservation.",
    "From Ancestral Roots to Digital Legacy.",
    "Preserving What Makes Every Indian Family Unique.",
    "A Living Repository of India's Family Wisdom.",
    "Your Family's Story Should Never Be Lost to Time.",
    "One Platform for India's Many Communities, Cultures and Traditions.",
    "Where Family Memories Become Generational Treasures.",
    "Humanity First. Family First. Legacy Forever.",
];

// 10 Humanity First statements (master doc).
export const HUMANITY_FIRST_STATEMENTS = [
    "Humanity First — Pioneering India's First Holistic Family Repository Platform.",
    "Humanity First: Building India's Biggest Vision for Family Legacy Preservation.",
    "India's Family Heritage, United on One Platform — An Initiative by Humanity First.",
    "Humanity First — Redefining Family Legacy Preservation Through India's Most Comprehensive Digital Family Repository.",
    "One Nation. Every Family. Every Tradition. One Holistic Repository — Humanity First.",
    "Humanity First — India's Pioneering Initiative to Digitally Preserve Family Histories, Traditions, Rituals and Generational Wisdom.",
    "More Than a Family Tree. A Complete Digital Universe of Indian Family Heritage — Powered by Humanity First.",
    "Humanity First — Bringing India's Diverse Cultures, Communities, Religions and Family Traditions Together on One Unique Platform.",
    "A First-of-Its-Kind Vision. A Holistic Family Legacy Platform. A Mission by Humanity First.",
    "Humanity First — Creating a New National Standard for Preserving India's Family Heritage, One Generation at a Time.",
];

// Everything the footer band rotates through (40 statements).
export const BAND_QUOTES = [...LEGACY_QUOTES, ...BRAND_STATEMENTS, ...HUMANITY_FIRST_STATEMENTS];
